import { combineReducers } from "redux";
import { Constant } from "../../Constant";

const name = (state = "", action) => {
    const { type, payload } = action;
    switch (type) {
        case Constant.action.GET_USER_PROFILE.DONE:
            return payload?.name;
        case Constant.action.RESET_PROFILE:
            return "";
        default:
            return state;
    }
};

const post = (state = "", action) => {
    const { type, payload } = action;
    switch (type) {
        case Constant.action.GET_USER_PROFILE.DONE:
            return payload?.post;
        case Constant.action.RESET_PROFILE:
            return "";
        default:
            return state;
    }
};

const interfaceUsername = (state = "", action) => {
    const { type, payload } = action;
    switch (type) {
        case Constant.action.GET_USER_PROFILE.DONE:
            return payload?.interfaceUsername ?? null;
        case Constant.action.RESET_PROFILE:
            return "";
        default:
            return state;
    }
};

const role = (state = "", action) => {
    const { type, payload } = action;
    switch (type) {
        //   case Constant.action.GET_USER_PROFILE.DONE:
        //       return payload?.role;
        case Constant.action.SET_ROLE:
            return payload;
        case Constant.action.RESET_PROFILE:
            return "ANONYMOUS";
        default:
            return state;
    }
};

const openID = (state = "", action) => {
    const { type, payload } = action;
    switch (type) {
        //   case Constant.action.GET_USER_PROFILE.DONE:
        //       return payload?.role;
        case Constant.action.SET_OPENID:
            return payload;
        case Constant.action.RESET_PROFILE:
            return "ANONYMOUS";
        default:
            return state;
    }
};

const email = (state = "", action) => {
     const { type, payload } = action;
     switch (type) {
         //   case Constant.action.GET_USER_PROFILE.DONE:
         //       return payload?.role;
         case Constant.action.GET_USER_PROFILE.DONE:
             return payload?.email;
         case Constant.action.RESET_PROFILE:
             return "ANONYMOUS";
         default:
             return state;
     }
};

const selectedSCRN = (state = "", action) => {
    const { type, payload } = action;
    switch (type) {
        case Constant.action.SET_SELECTED_SCRN:
            return payload;
        case Constant.action.RESET_PROFILE:
            return "";
        default:
            return state;
    }
};

const profile = combineReducers({
    name,
    post,
    interfaceUsername,
    role,
    openID,
    email,
    selectedSCRN,
    // email
});

export default profile;
